export default __webpack_public_path__ + "static/media/liquidity_provider_layer.27105963.png";